import * as THREE from 'three';
import { Game } from './game.js';
import { setupEnvironment } from './environment.js';
import { setupControls } from './controls.js';

async function init() {
    // Initialize Game and Scene
    const game = new Game();

    // Setup Environment
    setupEnvironment(game.scene);

    // Setup Controls
    const controls = setupControls();

    // Loading Screen Elements
    const loadingScreen = document.getElementById('loading-screen');
    const loadingText = document.getElementById('loading-text');

    if (!loadingScreen || !loadingText) {
        return;
    }

    // Wait for assets to laod before starting
    await game.loadAssets();

    // Update Loading Screen
    loadingText.textContent = "Let's Play!";
    loadingText.classList.add('play-button');

    // Event listener for Play Button
    loadingText.addEventListener('click', () => {

        loadingScreen.classList.remove('visible');
        loadingScreen.classList.add('hidden');

        // Spawn Initial Objects
        game.spawnSnowballs(8);
        game.spawnTrees(18);

        // Animation Loop
        const clock = new THREE.Clock();
        function animate() {
            requestAnimationFrame(animate);
            const deltaTime = clock.getDelta();
            game.update(deltaTime, controls.keysPressed); 
            game.render();
        }
        animate()
    })
}

init();